import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { FiMenu, FiX, FiMoon, FiSun } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';
import Logo from '../ui/Logo';

const PublicHeader = () => {
  const { theme, toggleTheme } = useTheme();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
    <nav className="sticky top-0 z-50 bg-white dark:bg-charcoal-900 border-b border-charcoal-200 dark:border-charcoal-800 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <Link
            to="/"
            className="cursor-pointer"
            onClick={() => setMobileMenuOpen(false)}
          >
            <Logo className="h-10" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={toggleTheme}
              className="p-2 rounded-full hover:bg-charcoal-100 dark:hover:bg-charcoal-800 text-charcoal-600 dark:text-charcoal-300 transition-colors"
              aria-label="Toggle dark mode"
            >
              {theme === 'dark' ? <FiSun size={20} /> : <FiMoon size={20} />}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 text-charcoal-600 dark:text-charcoal-300 hover:text-blue-600 dark:hover:text-blue-400"
              aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={mobileMenuOpen}
            >
              {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white dark:bg-charcoal-900 border-t border-charcoal-200 dark:border-charcoal-800 absolute w-full left-0 top-16 shadow-lg z-50">
          <div className="px-4 py-6 space-y-4">
            <div className="flex items-center justify-between py-2">
               <span className="text-base font-medium text-charcoal-600 dark:text-charcoal-300">Dark Mode</span>
               <button
                  onClick={toggleTheme}
                  className="p-2 rounded-full hover:bg-charcoal-100 dark:hover:bg-charcoal-800 text-charcoal-600 dark:text-charcoal-300 transition-colors"
                  aria-label="Toggle dark mode"
                >
                  {theme === 'dark' ? <FiSun size={20} /> : <FiMoon size={20} />}
               </button>
            </div>
          </div>
        </div>
      )}
    </nav>
    </>
  );
};

export default PublicHeader;
